'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import SuspenseWithLoader from '../SuspenseWithLoader';
import ProductListingPagePlaceholder from '../ProductListingPage/ProductListingPagePlaceholder';
// import CategoryPageLegacy from './CategoryPageLegacy';
import CategoryPageAlgolia from '../category-page-algolia';
const stripLeadingAndTrailingSlash = path => {
  const pathWithoutLeadingSlash = path.startsWith('/') ? path.slice(1) : path;
  const pathWithoutTrailingSlash = pathWithoutLeadingSlash.endsWith('/') ? pathWithoutLeadingSlash.slice(0, -1) : pathWithoutLeadingSlash;
  return pathWithoutTrailingSlash;
};

// `useAlgolia` is derived from the `use-new-category-page` cookie server-side in
// CategoryPageWrapper (via next/headers) and threaded down through
// CategoryPageClient. Consuming it as a prop keeps a single, request-scoped
// source of truth and avoids reading the cookie client-side from
// `document.cookie` — which can't see HttpOnly cookies and caused server/client
// hydration mismatches. Callers that don't pass the prop (CMS-driven wrappers,
// the legacy app) default to the Legacy page.
const CategoryPage = t0 => {
  const $ = _c(10);
  const {
    slug: slugProp,
    serverCategoryData
  } = t0;
  const location = useLocation();
  const pathname = location?.pathname || "";
  let t1;
  if ($[0] !== pathname || $[1] !== slugProp) {
    t1 = slugProp || stripLeadingAndTrailingSlash(pathname);
    $[0] = pathname;
    $[1] = slugProp;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const slug = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ProductListingPagePlaceholder />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== serverCategoryData || $[5] !== slug) {
    t3 = <CategoryPageAlgolia key={slug} slug={slug} serverCategoryData={serverCategoryData} />;
    $[4] = serverCategoryData;
    $[5] = slug;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== slug || $[8] !== t3) {
    t4 = <SuspenseWithLoader fallback={t2} key={slug}>{t3}</SuspenseWithLoader>;
    $[7] = slug;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
CategoryPage.propTypes = {
  slug: PropTypes.string,
  serverCategoryData: PropTypes.object
};
export default CategoryPage;